/**
 * Product Info Tabs Mobile Repositioning
 *
 * On mobile: Moves tabs after product__info-wrapper
 * On desktop: Keeps tabs in product__media-wrapper (below gallery)
 */

class ProductInfoTabsMobile {
  constructor() {
    this.breakpoint = 750; // Match Shopify's mobile breakpoint
    this.init();
  }

  init() {
    // Run on load
    this.repositionTabs();

    // Run on resize (debounced)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.repositionTabs();
      }, 250);
    });
  }

  repositionTabs() {
    const tabsContainer = document.querySelector('.product__info-tabs-container');
    if (!tabsContainer) return;

    const isMobile = window.innerWidth < this.breakpoint;
    const productInfoWrapper = document.querySelector('.product__info-wrapper');
    const productMediaWrapper = document.querySelector('.product__media-wrapper');

    if (!productInfoWrapper || !productMediaWrapper) return;

    if (isMobile) {
      // Move tabs after product info wrapper on mobile
      if (tabsContainer.parentElement !== productInfoWrapper.parentElement) {
        // Insert after product__info-wrapper in the DOM
        productInfoWrapper.insertAdjacentElement('afterend', tabsContainer);
      } else if (tabsContainer.previousElementSibling !== productInfoWrapper) {
        // Already in same parent, just reorder
        productInfoWrapper.insertAdjacentElement('afterend', tabsContainer);
      }

      // Ensure full width on mobile
      tabsContainer.classList.add('product__info-tabs--mobile');
    } else {
      // Move tabs back to media wrapper on desktop
      const videoWalkthrough = productMediaWrapper.querySelector('.product-video-walkthrough');

      if (videoWalkthrough) {
        // Insert after video walkthrough if it exists
        videoWalkthrough.insertAdjacentElement('afterend', tabsContainer);
      } else {
        // Otherwise append to end of media wrapper
        const mediaGallery = productMediaWrapper.querySelector('media-gallery');
        if (mediaGallery) {
          mediaGallery.insertAdjacentElement('afterend', tabsContainer);
        }
      }

      // Remove mobile class on desktop
      tabsContainer.classList.remove('product__info-tabs--mobile');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductInfoTabsMobile();
  });
} else {
  new ProductInfoTabsMobile();
}
